import { ASSISTANCE_USES, CALIFORNIA_COUNTIES } from 'components/global/Constant/constants';
import { AppForm } from 'components/uikit';
import { Button, Row, Col, Card } from 'react-bootstrap';
import { ChangeEvent, useEffect, useState } from 'react';
import { handleSubmission, initForm, QuickMatchingForm, QuickMatchingFormErrors, QuickMatchingFormTouched, validateForm } from './BusinessQuickMatching.helpers';

const BusinessQuickMatching = () => {
  const [businessForm, setBusinessForm] = useState<QuickMatchingForm>({
    county: "",
    yearBusinessOpened: "",
    loanAmount: "",
    loanPurpose: "",
    numberOfFullTimeEmployees: "",
    previousAnnualRevenue: ""
  });

  const [businessFormTouched, setBusinessFormTouched] = useState<QuickMatchingFormTouched>({});
  const [businessFormErrors, setBusinessFormErrors] = useState<QuickMatchingFormErrors>({});

  function onChange(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
    setBusinessForm({ ...businessForm, [e.target.name]: e.target.value });
  }

  function onBlur(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
    setBusinessFormTouched({ ...businessFormTouched, [e.target.name]: true });
  }

  useEffect(() => {
    async function fetchAndSetForm() {
      const businessForm = await initForm();
      if (businessForm) {
        setBusinessForm(businessForm);
      }
    }

    fetchAndSetForm();
  }, [])

  useEffect(() => {
    const errors = validateForm(businessForm);
    setBusinessFormErrors(errors);
  }, [businessForm])

  return (
    <Card className="border rounded-0 p-32 mb-40">
      <Row>
        <Col xs={{ offset: 3, span: 6 }} className="text-center">
          <h3 className="mt-16">Right Match, Right Now</h3>
          <p className="mt-16">{"You're just a few clicks away from the best loan options for your business."}</p>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col xs={{ offset: 3, span: 6 }}>
          <AppForm.Select
            label="What county is your business located?"
            control={{
              touched: !!businessFormTouched.county,
              errors: businessFormErrors.county || [],
              name: "county",
              onChange,
              onBlur,
              value: businessForm.county,
              options: CALIFORNIA_COUNTIES.map(a => ({ value: a, label: a })),
            }}
          />
          <AppForm.Input
            label="How many full-time employees does your business have?"
            control={{
              touched: !!businessFormTouched.numberOfFullTimeEmployees,
              errors: businessFormErrors.numberOfFullTimeEmployees || [],
              name: "numberOfFullTimeEmployees",
              onChange,
              onBlur,
              value: businessForm.numberOfFullTimeEmployees
            }}
          />
          <AppForm.Input
            label="When did you start your business?"
            control={{
              type: 'number',
              touched: !!businessFormTouched.yearBusinessOpened,
              errors: businessFormErrors.yearBusinessOpened || [],
              name: "yearBusinessOpened",
              onChange,
              onBlur,
              value: businessForm.yearBusinessOpened
            }}
          />
          <AppForm.Currency
            label="What was your business revenue last year?"
            control={{
              touched: !!businessFormTouched.previousAnnualRevenue,
              errors: businessFormErrors.previousAnnualRevenue || [],
              name: "previousAnnualRevenue",
              onChange,
              onBlur,
              value: businessForm.previousAnnualRevenue
            }}
          />
          <AppForm.Select
            label="What's the loan for?"
            control={{
              touched: !!businessFormTouched.loanPurpose,
              errors: businessFormErrors.loanPurpose || [],
              name: "loanPurpose",
              options: Object.values(ASSISTANCE_USES),
              onChange,
              onBlur,
              value: businessForm.loanPurpose
            }}
          />
          <AppForm.Currency
            label="How much are you looking to borrow?"
            control={{
              touched: !!businessFormTouched.loanAmount,
              errors: businessFormErrors.loanAmount || [],
              name: "loanAmount",
              onChange,
              onBlur,
              value: businessForm.loanAmount
            }}
          />
          <Button
            disabled={Object.values(businessFormErrors).some(e => e.length > 0)}
            size="lg"
            className="rounded w-100 mt-32"
            onClick={() =>
              handleSubmission(businessForm)
            }
          >
            Submit
          </Button>
        </Col>
      </Row>
    </Card>
  )
}

export default BusinessQuickMatching;
